import React from "react";

import CardBase from "../Cards/Base/Base";
import CardEvent from "../Cards/Event/Event";
import CardLovfortolkning from "../Cards/Lovfortolkning/Lovfortolkning";
import CardNormerendeProdukter from "../Cards/NormerendeProdukter/NormerendeProdukter";
import CardTilskudd from "../Cards/Tilskudd/Tilskudd";
import CardWithContentType from "../Cards/WithContentType/WithContentType";
import CardWithContentTypeAndDate from "../Cards/WithContentTypeAndDate/WithContentTypeAndDate";
// import CardWithPreface from "../Cards/WithPreface/WithPreface";

import { contentTypeCardMap } from "../../../lib/modules/listSearchUtils/contentTypeCardMap";

import type { BaseProps } from "../../../lib/modules/listSearchUtils/index.d";

// This component maps content types to the content specific card in the results view
export default function ListSearchResultCardSelector(props: Readonly<BaseProps>) {
  const { contentTypeDescriptor } = props;

  let CardComponent;

  // Expand this switch with more alternatives if content type specific cards are added for ListSearch
  switch (true) {
    case !!contentTypeDescriptor && contentTypeCardMap.event.indexOf(contentTypeDescriptor) !== -1:
      CardComponent = CardEvent;
      break;

    case !!contentTypeDescriptor && contentTypeCardMap.lovfortolkning.indexOf(contentTypeDescriptor) !== -1:
      CardComponent = CardLovfortolkning;
      break;

    case !!contentTypeDescriptor && contentTypeCardMap.normerende.indexOf(contentTypeDescriptor) !== -1:
      CardComponent = CardNormerendeProdukter;
      break;

    case !!contentTypeDescriptor && contentTypeCardMap.displayContentType.indexOf(contentTypeDescriptor) !== -1:
      CardComponent = CardWithContentType;
      break;

    case !!contentTypeDescriptor && contentTypeCardMap.displayWithContentTypeAndDate.indexOf(contentTypeDescriptor) !== -1:
      CardComponent = CardWithContentTypeAndDate;
      break;

    case !!contentTypeDescriptor && contentTypeCardMap.tilskudd.indexOf(contentTypeDescriptor) !== -1:
      CardComponent = CardTilskudd;
      break;

      // Currently no content types use "CardWithPreface"
      // case !!contentTypeDescriptor && contentTypeCardMap.displayWithPreface.indexOf(contentTypeDescriptor) !== -1:
      //   CardComponent = CardWithPreface;
      //   break;

    default:
      CardComponent = CardBase;
      break;
  }

  return <CardComponent {...props} />;
}
